import {OrderListColumns} from "../../components/list/models/OrderListColumns";

export default [
    "account",
    "side",
    "quantity",
    "code",
    "exchange",
    "limit",
    "average-price",
    "created",
    "updated",
] as OrderListColumns;
